import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import productsNotFound from "../../../assets/images/products-not-found.svg";
import ProductCard from "../../common/cards/productCard";

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from "swiper"; 
import { Navigation, Pagination } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

interface ProductDisplayComponentInterface {
  data?: any[];
  isNight?: boolean;
  activeDay?: string;
}

const ProductDisplayComponent: React.FC<ProductDisplayComponentInterface> = (
  props
) => {
  const { data, isNight = false, activeDay } = props;

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  return (
    <div className="routine-products">
      {data === undefined ? (
        <Spin indicator={antIcon} style={{ marginTop: "80px" }} />
      ) : data.length === 0 ? (
        <div className="routine-products__not-available">
          <div>
            <img
              className="routine-products__not-available__image"
              src={productsNotFound}
              alt="No items"
            />
          </div>
          <h4 className="routine-products__not-available__text">
            No items for {activeDay}!
          </h4>
        </div>
      ) : (
        <Swiper
          spaceBetween={20}
          slidesPerView={4}
          navigation
          pagination={{ clickable: true }}
          modules={[Navigation, Pagination]}
          onSlideChange={() => console.log("slide change")}
          onSwiper={(swiper: SwiperType) => console.log(swiper)}
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 15 },
            768: { slidesPerView: 3, spaceBetween: 15 },
            1024: { slidesPerView: 4, spaceBetween: 20 },
          }}
        >
          {data.map((rData: any, rDataIndex: number) => (
            <SwiperSlide
              key={rDataIndex}
              className="routine-products__product-items"
            >
              <div
                style={{
                  borderRadius: "10px",
                  backgroundColor: isNight ? "#6489b1" : "#b5cc4c",
                  color: isNight ? "#fff" : "#000",
                  paddingBlock: "6px",
                  paddingInline: "10px",
                  fontSize: "16px",
                  marginBottom: "10px",
                  textAlign: "center",
                  maxWidth:"fit-content",
                  marginInline: "auto",

                }}
              >
                {`${rDataIndex + 1} Step`}
              </div>
              <ProductCard data={rData} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};

export default ProductDisplayComponent;
